import React from "react";
import { ChevronRight, PanelRightOpen } from "lucide-react";

// Barra única no topo: título da página à esquerda e, colado nela, o cabeçalho
// do resumo à direita. O painel pendura direto embaixo desta barra, então os
// dois leem como uma peça só em vez de dois blocos soltos.
export default function CabecalhoPedidos({ resumoAberto, onAlternarResumo, filtrado, larguraPainel }) {
  return (
    <div className="flex items-stretch rounded-xl border bg-card shadow-sm overflow-hidden mb-0">
      <div className="flex-1 min-w-0 px-5 py-3">
        <h1 className="text-2xl font-bold leading-tight">Pedidos</h1>
        <p className="text-sm text-muted-foreground">Gerencie todos os pedidos realizados</p>
      </div>

      {resumoAberto ? (
        <div
          className="hidden xl:flex items-center gap-2 border-l bg-muted/40 px-4 shrink-0"
          style={{ width: larguraPainel }}
          data-e2e="resumo-cabecalho"
        >
          <span className="text-xs font-bold uppercase tracking-wider">Resumo</span>
          {filtrado ? (
            <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-primary/15 text-primary">
              filtrado
            </span>
          ) : null}
          <button
            type="button"
            onClick={onAlternarResumo}
            className="ml-auto p-1 rounded-md hover:bg-muted text-muted-foreground"
            title="Esconder resumo"
            data-e2e="resumo-fechar"
          >
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={onAlternarResumo}
          className="hidden xl:flex items-center gap-2 border-l px-4 shrink-0 text-muted-foreground hover:bg-muted transition-colors"
          title="Mostrar resumo"
          data-e2e="resumo-abrir"
        >
          <PanelRightOpen className="w-4 h-4" />
          <span className="text-xs font-bold uppercase tracking-wider">Resumo</span>
        </button>
      )}
    </div>
  );
}
